import { FormSelectSelectionLabel } from '../../../common/form/input/FormSelectSelectionLabel';
import {
  formatCodeName,
  encodeStringKey,
  decodeStringKey,
} from '../../../common/utils';
import { getAlgorithmSourceLabel } from '../utils';
import {
  type AlgorithmSourceDimensionFormDataType,
  AlgorithmSourceValidFormDataType,
} from './schema/types';

export const createAlgorithmSourceDimensionsOptionGroup = (
  algorithmSource: AlgorithmSourceValidFormDataType,
  sourceIndex = 0,
  encodeOptionValue: (
    algorithmSource: AlgorithmSourceValidFormDataType,
    dimension: AlgorithmSourceDimensionFormDataType,
  ) => string = encodeAlgorithmSourceDimensionOptionValue,
) => {
  const algorithmSourceLabel = getAlgorithmSourceLabel(algorithmSource);

  return {
    key: String(algorithmSource.id),
    label: algorithmSourceLabel,
    options: algorithmSource.dimensions.map((dimension) => {
      const dimensionLabel = formatCodeName(dimension);
      const value = encodeOptionValue(algorithmSource, dimension);
      return {
        sourceIndex,
        key: value,
        value,
        algorithmSource,
        dimension,
        label: dimensionLabel,
        displayLabel: (
          <FormSelectSelectionLabel supertitle={algorithmSourceLabel}>
            {dimensionLabel}
          </FormSelectSelectionLabel>
        ),
      };
    }),
  };
};

export const encodeAlgorithmSourceDimensionOptionValue = (
  algorithmSource: {
    id: number;
    dataObjectCode?: string | null | undefined;
  },
  dimension: {
    code: string;
    classifier?: { id: number };
  },
) =>
  encodeStringKey(
    'dimension',
    dimension.code,
    algorithmSource.id,
    algorithmSource.dataObjectCode ?? '',
    dimension.classifier?.id ?? '',
  );

export const decodeAlgorithmSourceDimensionOptionValue = (value: string) => {
  const [, dimensionCode, algorithmSourceId, dataObjectCode, classifierId] =
    decodeStringKey(value);
  return {
    dimensionCode,
    algorithmSourceId: Number(algorithmSourceId),
    dataObjectCode,
    classifierId: Number(classifierId) || undefined,
  };
};
